import {LamelareaImpl} from "./lamelarea.class";
import {LamellaSet} from "./lamel/lamella-set.class";
import {GeneralProfile} from "./profiles/general-profile/general-profile";

function syncProfile<T extends GeneralProfile>(
    profile: T,
    changes: Partial<LamellaSet>,
    lamellaSets: LamellaSet[]
): T | null {
    if (changes.material) {
        return {
            ...profile,
            materialType: changes.material,
            // Käytetään changes.color, jos se on annettu, muuten ensimmäisen lamella-setin väri
            color: changes.color || lamellaSets[0].color
        } as T;
    } else if (changes.color) {
        return { ...profile, color: changes.color } as T;
    }
    return null;
}

export function syncMountingProfile(
    lamelArea: LamelareaImpl,
    changes: Partial<LamellaSet>
): GeneralProfile | null {
    return syncProfile(lamelArea.mountingProfile, changes, lamelArea.lamellaSets);
}

export function syncCoverProfile(
    lamelArea: LamelareaImpl,
    changes: Partial<LamellaSet>
): GeneralProfile | null {
    return syncProfile(lamelArea.coverProfile, changes, lamelArea.lamellaSets);
}